import React from 'react';

import NextCheckinMetrics from './NextCheckinMetrics';
import PlanMetrics from './PlanMetrics';
import ProgressMetrics from './ProgressMetrics';

const OrganizationMetrics = props => {
    let org = props.organization;

    let plan = <PlanMetrics organization={org} />;
    if (props.hidePlan) {
        plan = null;
    }

    return (
        <div className="OrganizationMetrics">
            <NextCheckinMetrics
                documents={org.documents}
                checkindate={org.next_checkin.date}
            />
            <ProgressMetrics organization={org} />
            {plan}
        </div>
    );
};

export default OrganizationMetrics;
